/**
 * Logging level.
 */
export enum LoggingLevel {
  LOGGING_OFF = 0,
  ERRORS = 1,
  WARNINGS = 2,
  DEBUG = 3
}
